export const INIT_SETTINGS = 'INIT_SETTINGS';
export const SAVE_SETTINGS = 'SAVE_SETTINGS';